module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": function($event) {
        _vm.tamporize('http://localhost:8080/static/ajax/test-ajax.json')
      }
    }
  }, [_vm._v("Get Ajax")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-block",
    on: {
      "click": function($event) {
        _vm.tamporize('http://localhost:8080/static/ajax/test-ajax0.json')
      }
    }
  }, [_vm._v("Call wrong file")])])]), _vm._v(" "), _c('div', {
    staticClass: "segment"
  }, [_c('div', {
    staticClass: "ui inverted dimmer",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "ui text loader"
  }, [_vm._v("waiting 2000ms")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ajaxResponse))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84fc68d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ajax-call.vue
// module id = 100
// module chunks = 0